import AboutUs from './AboutUs';
import Services from './Services';
import Projects from './Projects';
import Clients from './Clients';
import Contact from './Contact';

function Home() {
  return (
    <div>
      <AboutUs />
      <Services />
      <section id="projects">
        <Projects />
      </section>
      <Clients/>
      <Contact />
    </div>
  );
}

export default Home;
